import { PageHeading } from '~/components/common/PageHeading';
import { SimplePanel } from '~/components/common/Panel';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { CreateDepositionalWikiForm } from '~/components/upload/depositional-wiki/create-depositional-wiki-form';

export default function DepositionalWikiCreateRoute() {
  useBreadcrumb('routes/upload/depositional/create', 'Create Geology Wiki');

  return (
    <>
      <PageHeading>Create Geology Wiki</PageHeading>

      <SimplePanel title="Create Geology Wiki">
        <CreateDepositionalWikiForm />
      </SimplePanel>
    </>
  );
}
